import { HiServerStack } from "@onemind-services-llc/react-icons-ng/hi";
import { MdOutlineInsights, MdSecurity } from "@onemind-services-llc/react-icons-ng/md";
import { ContentCard } from "@/components/contentCard";

export const HOSTED_ELASTIC_FEATURES = {
  title: "Features of Hosted Elastic",
  list: [
    {
      icon: HiServerStack,
      title: "​Infrastructure & Scaling",
      content: (
        <ContentCard
          points={[
            "Auto-scaling clusters with hot/warm/cold tiers.",
            "Redundant architecture across availability zones.",
            "Built-in snapshot backups and point-in-time recovery.",
          ]}
        />
      ),
    },
    {
      icon: MdSecurity,
      title: "Security & Compliance",
      content: (
        <ContentCard
          points={[
            "Elastic Security integration for SIEM.",
            "RBAC, audit logging, and compliance reports.",
            "Data encrypted at rest and in transit",
          ]}
        />
      ),
    },
    {
      icon: MdOutlineInsights,
      title: "​Observability & Performance",
      content: (
        <ContentCard
          points={[
            "Built-in APM dashboards.",
            "Real-time analytics with optimized index lifecycle management.",
            "Pre-configured alerting for key performance metrics",
          ]}
        />
      ),
    },
  ],
};
